export default __webpack_public_path__ + "static/media/Helmet-Detection.485cf307.jpg";